export const DefaultEnableArmControl = false;

/** Joystick mapping while arm control is active. */
export const ARM_STICK_MODE_TRANSLATE = "translate";
export const ARM_STICK_MODE_ROTATE = "rotate";
export const DefaultArmStickMode = ARM_STICK_MODE_TRANSLATE;

/** Linear scale (m/s) at stick full deflection * speedMultiplier */
export const ARM_LINEAR_SPEED = 0.15;
/** Angular scale (rad/s) at stick full deflection * speedMultiplier */
export const ARM_ANGULAR_SPEED = 0.5;

export const armStatesInfo = {
    state: {
        topic: "/arm/state",
        type: "std_msgs/String",
        default: null,
        transform: (msg) => {
            const raw = typeof msg === "string" ? msg : msg?.data;
            if (!raw) return null;
            try {
                return typeof raw === "string" ? JSON.parse(raw) : raw;
            } catch {
                return null;
            }
        },
    },
};

export const ARM_HEALTH_TOPIC = "/arm/health";
